export default "__VITE_ASSET__BqAIAfBt__"